module.exports = __webpack_public_path__ + "static/media/notificationBot.2aebb5ce.mp3";